import { useMemo } from "react";
import { Controller } from "react-hook-form";

import { GoogleFreeBookingLinksConnectionStatus } from "@/lib/gql/__generated__/graphql";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import type { FormOptionType } from "@/components/ui/form/_types/type";
import { SelectField } from "@/components/ui/form/fields/select-field";

import { useGoogleFreeBookingLinksSettingsContext } from "../../../_context";

export const FormConnectionStatus = () => {
	const { form } = useGoogleFreeBookingLinksSettingsContext();
	const {
		control,
		formState: { errors },
	} = form;
	const options = useMemo<Array<FormOptionType>>(
		() => [
			{
				id: GoogleFreeBookingLinksConnectionStatus.Connectable,
				label: "連携する",
				value: GoogleFreeBookingLinksConnectionStatus.Connectable,
			},
			{
				id: GoogleFreeBookingLinksConnectionStatus.NotConnected,
				label: "連携しない",
				value: GoogleFreeBookingLinksConnectionStatus.NotConnected,
			},
		],
		[],
	);

	return (
		<QuestionForMain
			title={"連携設定"}
			required
			inputChildren={
				<Controller
					name="status"
					control={control}
					render={({ field }) => (
						<SelectField
							className="w-fit"
							value={field.value}
							options={options}
							errorMessage={errors?.status?.message}
							handleValueChange={field.onChange}
						/>
					)}
				/>
			}
		/>
	);
};
